import I18n from "common/i18n";
import { usePlaySound } from "common/utils";
import { ProgressSubTab } from "./UserPageTab";

type ProgressSegmentControlProps = {
  value: ProgressSubTab;
  onChange: (tab: ProgressSubTab) => void;
};

const SegmentButton = ({
  active,
  labelKey,
  iconName,
  onClick,
}: {
  active: boolean;
  labelKey: string;
  iconName: string;
  onClick: () => void;
}) => (
  <button
    className={`type-inherit-font flex-col-el flex-center gap-1 w-full h-[130px] px-2 py-2 rounded-2xl border-2 border-solid cursor-pointer transition-colors shadow-[0_3px_0_rgba(63,74,97,0.14),0_4px_10px_rgba(63,74,97,0.08)] active:translate-y-[2px] ${
      active
        ? "border-green-80 bg-green-60 text-textcolor-black"
        : "border-outline bg-white text-textcolor-black/60 hover:bg-green-40/20"
    }`}
    onClick={onClick}
  >
    <div className="flex-col-el flex-center w-[48px] h-[48px] shrink-0">
      <span className="material-symbols-outlined type-hero !leading-none">{iconName}</span>
    </div>
    <p className="type-text type-sm leading-tight whitespace-pre text-center">{I18n.t(labelKey)}</p>
  </button>
);

export const ProgressSegmentControl = ({ value, onChange }: ProgressSegmentControlProps) => {
  const play = usePlaySound();

  const handleClick = (tab: ProgressSubTab) => () => {
    play();
    onChange(tab);
  };

  return (
    <div className="flex-col-el gap-3 w-full">
      <SegmentButton
        active={value === ProgressSubTab.COURSE_CHART}
        labelKey="MSG_USER_PROFILE_PROGRESS_COURSE"
        iconName="monitoring"
        onClick={handleClick(ProgressSubTab.COURSE_CHART)}
      />
      <SegmentButton
        active={value === ProgressSubTab.COURSE_CLEARED}
        labelKey="MSG_USER_PROFILE_PROGRESS_COURSE_CLEARED_BTN"
        iconName="emoji_events"
        onClick={handleClick(ProgressSubTab.COURSE_CLEARED)}
      />
      <SegmentButton
        active={value === ProgressSubTab.CREATOR_CHART}
        labelKey="MSG_USER_PROFILE_PROGRESS_CREATOR"
        iconName="auto_graph"
        onClick={handleClick(ProgressSubTab.CREATOR_CHART)}
      />
      <SegmentButton
        active={value === ProgressSubTab.CREATOR_PROJECT}
        labelKey="MSG_USER_PROFILE_PROGRESS_CREATOR_PROJECT_BTN"
        iconName="extension"
        onClick={handleClick(ProgressSubTab.CREATOR_PROJECT)}
      />
    </div>
  );
};
